import React from 'react';
import Headline from 'headline';
import { useQuery } from '@apollo/react-hooks';
import Icon from 'icon';
import useGlobal from 'hooks/useGlobal';
import Banner from 'shared/banner-title';
import useCustomerAccessToken from 'hooks/useCustomerAccessToken';
import { getCheckoutWithShipping } from '@/queries/getCart';
import getCheckoutId from '@/queries/getCheckoutId';

import s from './header.module.scss';

export default function PageCartHeader({ noNav }) {
  const { customerAccessToken } = useCustomerAccessToken();
  const { data } = useQuery(getCheckoutId);
  const cartResponse = useQuery(getCheckoutWithShipping, {
    skip: !data?.checkout?.checkoutId,
    variables: {
      id: data?.checkout?.checkoutId
    }
  });
  const { state, emit } = useGlobal();
  const step = state?.checkout?.step;
  const nextStep = step =>
    emit.update({
      checkout: {
        step
      }
    });
  return (
    <Banner custom>
      <div className={s.root}>
        {!noNav && (
          <div className={s.breadCrumbs}>
            <a className={s.home} href="https://cohortcs.com/">
              <Icon icon="house" className={s.house} />
              <span className={s.homeText}>Home</span>
            </a>
            <Icon icon="angle-right" />
            <button
              className={step === 'summary' || !step ? s.active : ''}
              type="button"
              onClick={() => nextStep('summary')}
            >
              Summary
            </button>
            {customerAccessToken && (
            <>
              {' '}
              <Icon icon="angle-right" />
              <button
                type="button"
                className={step === 'shipping' ? s.active : ''}
                onClick={() => nextStep('shipping')}
              >
              Shipping
              </button>
              <Icon icon="angle-right" />
              <button
                type="button"
                className={step === 'payment' ? s.active : ''}
                disabled={
                !cartResponse?.data?.node?.availableShippingRates.ready ||
                !cartResponse?.data?.node?.email
              }
                onClick={() => nextStep('payment')}
              >
              Payment
              </button>
            </>
)}
          </div>
        )}
      </div>
    </Banner>
  );
}
